module.exports = __webpack_public_path__ + "img/diseno-parametrico.0944eeb7.jpg";